import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {GetCompanyUserDetailsResult} from "../types/GetCompanyUserDetailsResult";

export const useGetCompanyUser = (userName?: string) => {
	const { data, isLoading } = useQuery({
		queryKey: ['user', userName],
		queryFn: async () => await apiClient.get('user/details', {
			params: {
				userName: userName
			}
		}) as GetCompanyUserDetailsResult
	});

	return {
		data,
		isLoading
	};
};
